import React from 'react';
import PropTypes from 'prop-types';

import Captcha from 'eventbrite_design_system/captcha/Captcha';
import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';

export default class CaptchaField extends React.PureComponent {
    static propTypes = {
        recaptcha2PublicKey: PropTypes.string,
        showCaptcha: PropTypes.bool,

        submitFailed: PropTypes.bool,
    };

    render() {
        const { recaptcha2PublicKey, showCaptcha } = this.props;

        if (!showCaptcha) {
            return null;
        }

        return (
            <div className="eds-l-pad-top-2 eds-l-mar-left-2">
                <ValidationFormField
                    name="captcha"
                    label="captcha"
                    hideLabel={true}
                    required={true}
                >
                    <Captcha sitekey={recaptcha2PublicKey} />
                </ValidationFormField>
            </div>
        );
    }
}
